import { GridRowModel } from "@mui/x-data-grid-pro";

export const affordabilitySection = [
  "income",
  "currentMonthlyCommitments",
  "monthlyLivingCosts",
  "newBoatCosts",
  "workings",
] as const;

export const incomeSection = [
  "mainApplicantIncome",
  "jointApplicantIncome",
  "mainApplicantOtherIncome",
  "jointApplicantOtherIncome",
];
export const currentMonthlyCommitmentSection = [
  "mortgageRent",
  "totalLoans",
  "outstandingCreditCardBalances",
  "outstandingBNPLBalances",
  "otherCommittedExpenses",
];
export const monthlyLivingCostSection = [
  "numberOfDependants",
  "onsGeneratedLivingCosts",
];
export const newBoatCostSection = ["monthlyLoanPayment", "monthlyRunningCosts"];
export const isAffordableSection = ["isAffordable"];

export const isAffordable = "isAffordable";

export type Sections = typeof affordabilitySection[number];

export interface AffordabilityGridRow extends GridRowModel {
  id: string;
  key: string;
  title: string;
  declared?: any;
  openBanking?: any;
  variance?: any;
  manual?: any;
}
